import { Routes, Route, Navigate } from "react-router-dom";
import { useMsal, useIsAuthenticated, useAccount } from "@azure/msal-react";
import { useEffect } from "react";
import { loginRequest } from "./auth/msal";
import { AppShell } from "./components/AppShell";
import { AccessGate } from "./components/AccessGate";
import { AdminLanding } from "./pages/AdminLanding";
import { ApprovalDetail } from "./pages/ApprovalDetail";
import { AllEstimates } from "./pages/AllEstimates";
import { Rules } from "./pages/Rules";
import { ClaimantProfile } from "./pages/ClaimantProfile";
import { Reports } from "./pages/Reports";
import { Rates } from "./pages/Rates";
import { Approvers } from "./pages/Approvers";
import { PwsProfile } from "./pages/PwsProfile";
import { HomeProfile } from "./pages/HomeProfile";
import { FunderProfile } from "./pages/FunderProfile";
import { Audit } from "./pages/Audit";
import { Modules } from "./pages/Modules";
import { Users } from "./pages/Users";

export default function App() {
  const { instance, accounts } = useMsal();
  const isAuthed = useIsAuthenticated();
  const account = useAccount(accounts[0]);

  useEffect(() => {
    if (!isAuthed && accounts.length === 0) {
      instance.loginRedirect(loginRequest).catch(console.error);
    }
  }, [isAuthed, accounts, instance]);

  if (!isAuthed || !account) {
    return (
      <div className="min-h-screen flex items-center justify-center text-slate-500">
        Signing you in to Microsoft...
      </div>
    );
  }

  return (
    <AccessGate allow={["approver", "admin"]}>
      <Routes>
        <Route element={<AppShell />}>
          <Route path="/" element={<AdminLanding />} />
          <Route path="/approvals" element={<AdminLanding />} />
          <Route path="/approvals/:id" element={<ApprovalDetail />} />
          <Route path="/all-estimates" element={<AllEstimates />} />
          <Route path="/claimant/:oid" element={<ClaimantProfile />} />
          <Route path="/reports" element={<Reports />} />
          <Route path="/rates" element={<Rates />} />
          <Route path="/approvers" element={<Approvers />} />
          <Route path="/pws/:id" element={<PwsProfile />} />
          <Route path="/home/:id" element={<HomeProfile />} />
          <Route path="/funder/:id" element={<FunderProfile />} />
          <Route path="/audit" element={<Audit />} />
          <Route path="/rules" element={<Rules />} />
          <Route path="/modules" element={<Modules />} />
          <Route path="/users" element={<Users />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </AccessGate>
  );
}
